

const ServiceHighlights = () => {
  const services = [
    {
      icon: 'VideoCameraIcon',
      title: 'Professional Editing',
      description: 'Expert cuts, transitions, and pacing that keep viewers engaged',
      included: ['Color correction', 'Audio mixing', 'B-roll integration', 'Smooth transitions'],
    },
    {
      icon: 'SparklesIcon',
      title: 'Motion Graphics',
      description: 'Eye-catching animations and visual effects that elevate your content',
      included: ['Lower thirds', 'Animated titles', 'Logo animations', 'Custom graphics'],
    },
    {
      icon: 'MusicalNoteIcon',
      title: 'Sound Design',
      description: 'Crystal-clear audio with professional mixing and sound effects',
      included: ['Noise reduction', 'Audio leveling', 'Sound effects', 'Music integration'],
    },
    {
      icon: 'LanguageIcon',
      title: 'Captions & Subtitles',
      description: 'Accurate captions that boost accessibility and engagement',
      included: ['Auto-generated', 'Manual review', 'Custom styling', 'Multi-language'],
    },
  ];

  return null;
};

export default ServiceHighlights;